// Corre una promesa con un tope de tiempo. Si se pasa, RECHAZA con un error
// etiquetado en vez de colgarse para siempre. Se usa en puntos de setup que
// pasan ANTES del watchdog del stream (ej. getSession de Supabase, que si el
// refresh del token se traba no resuelve nunca) — sin esto, el asistente queda
// en "Pensando" indefinido. El `label` dice QUÉ llamada venció (diagnóstico).
//
// (Gemelo del helper que ya usa el Asistente V2 en useV2Chat.ts; se extrae acá
// para reusarlo también en el Director de Estudio sin tocar V2.)
export function withTimeout<T>(p: Promise<T>, ms: number, label: string): Promise<T> {
  const startedAt = Date.now();
  return new Promise<T>((resolve, reject) => {
    const t = setTimeout(() => {
      // Log de FALLA: esta operación se colgó y la cortamos.
      console.warn(
        `[video-agent][timeout] ⏱ "${label}" venció tras ${Math.round(ms / 1000)}s`,
      );
      reject(new Error(`timeout:${label} (${ms}ms)`));
    }, ms);
    p.then(
      (v) => {
        clearTimeout(t);
        const dur = Date.now() - startedAt;
        if (dur > 3000) {
          console.log(
            `[video-agent][lento] "${label}" tardó ${(dur / 1000).toFixed(1)}s (OK)`,
          );
        }
        resolve(v);
      },
      (e) => {
        clearTimeout(t);
        reject(e);
      },
    );
  });
}
